import { render, staticRenderFns } from "./PayslipHistoryModal.vue?vue&type=template&id=b2fd1556"
import script from "./PayslipHistoryModal.vue?vue&type=script&lang=js"
export * from "./PayslipHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports